/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import React, { useState } from 'react';
import GetPayHistoryActionBox from '../ActionIcons/GetPayHistoryActionBox/GetPayHistoryActionBox';
import './tables_styles.css';
import EmployeeNamePic from '../EmployeeNamePic/EmployeeNamePic';
import ResignationARModalController from '../../Modals/ActionRequiredModals/ResignationARModal/ResignationARModalController';
import { actionRequiredService } from '../../../api/services/actionRequiredService';
import { useAppSelector } from '../../../infra/hooks';
import _ from 'lodash';
import { themes } from '../../themes/themes';
import { arabicDataGrid, baseDateFormatting } from '../../helper';
import { useTranslate } from '../../../hooks';
import { DateField } from '../../../components';

interface Propval {
  trans: any;
}

const Resignation = ({ trans }: Propval) => {
  const [openModal, setOpenModal] = useState(false);
  const [fullData, setFullData] = useState<any>({});
  const [historyData, setHistoryData] = useState<any>({});

  const storedARData = useAppSelector(
    (state) => state.actionRequiredSlice.actionRequiredData,
  );

  const getComplaintHistoryCall = (empId: any, companyId: any, deptId: any) => {
    actionRequiredService
      .getComplaintHistory(empId, deptId, companyId)
      .then((result) => {
        setHistoryData(result?.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleTransferView = (complaint: any) => {
    setFullData(complaint);

    getComplaintHistoryCall(
      complaint.emp_id,
      complaint.company_id,
      complaint.department_id,
    );
  };
  const getStatus = ['Pending', 'Approved', 'Rejected'];

  const tableColumns: any = [
    {
      field: 'empId',
      headerName: trans('Emp Id'),
      width: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
    },
    {
      field: 'empName',
      headerName: trans('Emp Name'),

      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
      renderCell: (params: any) => {
        return (
          <EmployeeNamePic
            name={params?.row?.empName}
            picture={params?.row?.empPic}
          />
        );
      },
    },
    {
      field: 'designation',
      headerName: trans('Designation'),
      width: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
    },
    {
      field: 'typeOfContract',
      headerName: trans('Type Of Contract'),
      width: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
    },

    {
      field: 'exitDate',
      headerName: trans('Exit Date'),
      width: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
      renderCell: (params: any) => (
        <DateField value={params?.row?.exitDate} format={baseDateFormatting} />
      ),
    },
    {
      field: 'resignationDate',
      headerName: trans('Resignation Date'),
      width: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
      renderCell: (params: any) => (
        <DateField
          value={params?.row?.resignationDate}
          format={baseDateFormatting}
        />
      ),
    },

    {
      field: 'action',
      flex: 1,
      headerName: trans('Action'),
      headerClassName: 'header',
      headerAlign: 'center',
      align: 'center',
      renderCell: (params: any) => {
        if (params?.row?.status == 0) {
          return (
            <GetPayHistoryActionBox
              onView={() => {
                handleTransferView(params?.row?.fullData);
                setOpenModal(true);
              }}
            />
          );
        } else {
          return (
            <Typography
              style={{
                fontSize: '14px',
                color: themes.greyDefault_500,
              }}
            >
              {getStatus[params?.row?.status]}
            </Typography>
          );
        }
      },

      width: 200,
      height: 70,
    },
  ];

  const row_data = _.map(storedARData, (data: any) => {
    return {
      id: data?.id,
      empId: `#${data?.staff_id}`,
      empName: `${data?.first_name} ${data?.last_name}`,
      designation: data?.designation_name,
      exitDate: data?.notice_date,
      resignationDate: data?.registration_date,
      typeOfContract: data?.contract_type,
      fullData: data,
      status: data?.status,
    };
  });

  const { isRTL } = useTranslate();

  return (
    <>
      <Box
        className="ar_table"
        sx={{
          '& .header': {
            backgroundColor: '#F5F5F5',
          },

          width: '100%',
          marginTop: '2em',
        }}
      >
        <DataGrid
          sx={{
            color: '#081735',
            font: 'normal normal normal 14px/24px Lato;',
          }}
          autoHeight
          disableExtendRowFullWidth
          disableSelectionOnClick
          disableColumnFilter
          disableColumnMenu
          localeText={isRTL ? arabicDataGrid : undefined}
          rows={row_data}
          columns={tableColumns}
          componentsProps={{
            pagination: {
              labelRowsPerPage: trans('Rows per page'),
            },
          }}
        />
      </Box>
      {openModal && (
        <ResignationARModalController
          closeModal={() => setOpenModal(false)}
          isModalOpen={openModal}
          fullData={fullData}
          historyData={historyData}
        />
      )}
    </>
  );
};

export default Resignation;
